import { FeApi } from '@/api/fe-api';
import type { Metric, MetricUnit } from '@/warranty-v3/entities/metric';

import { guaranteedValueMapper } from './guaranteed-value-mapper';
import { ldSeriesMapper, valueSeriesMapper } from './metrics-series-mapper';

const METRIC_UNIT_BY_ID: Record<string, MetricUnit> = {
  capacity: 'MWh',
};

function deriveUnit(metricId: string): MetricUnit {
  return METRIC_UNIT_BY_ID[metricId] ?? 'percent';
}

export function metricMapper(data: FeApi.Metric): Metric {
  return {
    id: data.id,
    name: data.name,
    description: data.description ?? undefined,
    order: data.order,
    unit: deriveUnit(data.id),
    value: data.value,
    guaranteedValue: data.guaranteed_value
      ? guaranteedValueMapper(data.guaranteed_value)
      : undefined,
    capedLD: data.caped_ld ?? undefined,
    valueSeries: data.value_series
      ? valueSeriesMapper(data.value_series)
      : undefined,
    capedLDSeries: data.caped_ld_series
      ? ldSeriesMapper(data.caped_ld_series)
      : undefined,
  };
}
